module.exports = __webpack_public_path__ + "img/5.6f13e472.jpg";